/**
 * Copy for `./HearFromOurPeople.tsx`, in English, French and Spanish. The French and Spanish
 * slides repeat the English quote and role.
 */
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { HearFromOurPeopleContent } from "./HearFromOurPeople";

/**
 * Hear From Our People copy, by language. Imported by `src/pages/about-us/careers/index.tsx`
 * (section title and content) and used by `./HearFromOurPeople.tsx` as its fallback.
 *
 * Each `videoId` is a full YouTube watch URL rather than a bare id. `Video` from
 * `@ryerson/frontend.media` appends it to `https://www.youtube.com/embed/`, and the video still
 * plays because `react-player` scans that combined string with its YouTube URL pattern, and the
 * first match is the embedded `watch?v=` URL, from which it takes the 11-character id.
 */
export const HearFromOurContent: LanguageContent<HearFromOurPeopleContent> = {
	en: {
		title: "Hear From Our People",
		slides: [
			{
				quote: `There is a lot of opportunity to make an impact, not only for Ryerson, but for the industry as a whole.`,
				name: "Chelsea",
				title: "Sales",
				imageUrl: "/images/careers/HearFromOurPeople.jpg",
				videoId: "https://www.youtube.com/watch?v=-kAeBM2X-z8&ab_channel=Ryerson",
			},
		],
	},
	fr: {
		title: "Témoignages de notre équipe",
		slides: [
			{
				quote: `There is a lot of opportunity to make an impact, not only for Ryerson, but for the industry as a whole.`,
				name: "Chelsea",
				title: "Sales",
				imageUrl: "/images/careers/HearFromOurPeople.jpg",
				videoId: "https://www.youtube.com/watch?v=-kAeBM2X-z8&ab_channel=Ryerson",
			},
		],
	},
	es: {
		title: "Escuche sobre nuestras personas",
		slides: [
			{
				quote: `There is a lot of opportunity to make an impact, not only for Ryerson, but for the industry as a whole.`,
				name: "Chelsea",
				title: "Sales",
				imageUrl: "/images/careers/HearFromOurPeople.jpg",
				videoId: "https://www.youtube.com/watch?v=-kAeBM2X-z8&ab_channel=Ryerson",
			},
		],
	},
};
